import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { ArrowRight, MapPin } from 'lucide-react';

export const HeroSection = () => {
  const { language, t } = useLanguage();
  const scrollToSection = (id) => document.getElementById(id)?.scrollIntoView({ behavior:'smooth' });

  return (
    <section
      id="home"
      className="relative overflow-hidden pt-36 pb-24 bg-[#062A4F] text-white min-h-[690px] flex items-center"
    >
      <div
        className="absolute inset-0 bg-cover bg-center lg:bg-[center_right]"
        style={{ backgroundImage: "url('/ateed-rak-sketch.webp')" }}
        aria-hidden="true"
      />

      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(90deg, rgba(3,29,55,0.99) 0%, rgba(4,39,72,0.97) 28%, rgba(5,47,87,0.84) 47%, rgba(5,47,87,0.34) 66%, rgba(5,47,87,0.05) 100%)'
        }}
        aria-hidden="true"
      />

      <div
        className="absolute inset-0 bg-gradient-to-t from-[#062A4F]/35 via-transparent to-transparent"
        aria-hidden="true"
      />

      <div className="relative z-10 max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <span className="inline-block text-sm uppercase tracking-[0.18em] font-bold text-[#9CDCF6] mb-5 drop-shadow-sm">
            {t.hero.eyebrow}
          </span>

          <h1 className="text-4xl sm:text-6xl lg:text-7xl font-bold leading-[1.04] tracking-tight max-w-5xl text-white drop-shadow-[0_2px_10px_rgba(0,0,0,0.35)]">
            {t.hero.title}
          </h1>

          <p className="mt-7 text-lg sm:text-xl text-slate-100 max-w-3xl leading-relaxed drop-shadow-sm">
            {t.hero.body}
          </p>

          <div className={`mt-9 flex flex-wrap gap-4 ${language === 'ar' ? 'justify-end' : ''}`}>
            <Button
              onClick={() => scrollToSection('apply')}
              className="bg-[#D9A744] hover:bg-[#c69638] text-[#10243b] px-7 py-6 rounded-lg text-base font-bold group shadow-lg"
            >
              {t.hero.primary}
              <ArrowRight className={`w-5 h-5 ${language === 'ar' ? 'mr-2 rotate-180' : 'ml-2'}`} />
            </Button>

            <Button
              onClick={() => scrollToSection('programs')}
              variant="outline"
              className="border-white/55 bg-[#062A4F]/35 backdrop-blur-sm hover:bg-white hover:text-[#062A4F] text-white px-7 py-6 rounded-lg text-base font-semibold"
            >
              {t.hero.secondary}
            </Button>
          </div>

          <div className={`mt-9 flex items-center gap-2 text-sm text-slate-200 ${language === 'ar' ? 'justify-end' : ''}`}>
            <MapPin className="w-4 h-4 text-[#25A8DF]" />
            <span>{t.hero.location}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
